import React from 'react';
import { setCurrentView } from 'core/utils';
import { MarkAsShippedBulkViewStore } from 'modules/order/stores';
import { MarkAsShippedBulkTemplate } from 'themes/modules/order/pages';

@setCurrentView(
	(rootStore, componentProps) => new MarkAsShippedBulkViewStore(rootStore, componentProps),
	'markAsShippedBulkViewStore'
)
class MarkAsShippedBulk extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <MarkAsShippedBulkTemplate {...this.props} />;
	}
}

export default MarkAsShippedBulk;



// WEBPACK FOOTER //
// ./src/modules/order/pages/MarkAsShippedBulk.jsx